import {copyForPast} from './copy';

export default copyForPast;
